import { _className } from '../../../utils/classname.utils';
import { renderIf } from '../../../utils/render.utils';
import style from './DebitCard.css';
import LockIcon from '../Icons/LockIcon';
import ClockIcon from '../Icons/ClockIcon';
import CardStatus from '../../../constants/card.status';
import { CardProvidersLogos } from '../../../clients/card.networks';
import FormatterUtils from '../../../utils/formatter.utils';
import { CardType, getCardAssetURL } from '../../../clients/card.backgrounds';

export default function DebitCard({ className = '', card, ...props }) {
  return (
    <div className={`${className} ${style['debit-card']}`} {...props}>
      <img
        className={style['card-bg']}
        src={getCardAssetURL(card?.organizationCode, CardType.BACKGROUND)}
      />
      <img
        className={`${style['card-client']} ${_className(
          ![CardStatus.ACTIVE, CardStatus.SET_PIN].includes(card.status),
          'block-blur',
        )}`}
        src={getCardAssetURL(card?.organizationCode, CardType.LOGO)}
      />
      <img
        className={`${style['card-provider']} ${_className(
          ![CardStatus.ACTIVE, CardStatus.SET_PIN].includes(card.status),
          'block-blur',
        )}`}
        src={CardProvidersLogos[card.network]}
      />
      {renderIf(
        !!card.number,
        <span
          className={`${style['card-number']} ${_className(
            ![CardStatus.ACTIVE, CardStatus.SET_PIN].includes(card.status),
            'block-blur',
          )}`}
        >
          {FormatterUtils.cardNumber(card.number)}
        </span>,
      )}

      {renderIf(
        ![CardStatus.ACTIVE, CardStatus.SET_PIN].includes(card.status),
        <div className={style.overlay}>
          <span>
            {card.status === CardStatus.LOCKED ? <LockIcon /> : <ClockIcon />}
          </span>
        </div>,
      )}
    </div>
  );
}
